import PropTypes from 'prop-types';
import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { getInitialize, logoutSuccess } from 'src/redux/slices/auth';

// ----------------------------------------------------------------------

JwtProvider.propTypes = {
  children: PropTypes.node,
};

function JwtProvider({ children }) {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getInitialize());
  }, [dispatch]);

  // Cross-tab logout listener:
  // When another tab logs out, it writes to localStorage('logout_event').
  // The 'storage' event fires in ALL OTHER tabs — we use it to clear
  // auth state here so every tab logs out in sync.
  useEffect(() => {
    const handleStorageChange = (e) => {
      if (e.key === 'logout_event') {
        sessionStorage.removeItem('accessToken');
        dispatch(logoutSuccess());
      }
    };
    window.addEventListener('storage', handleStorageChange);
    return () => window.removeEventListener('storage', handleStorageChange);
  }, [dispatch]);

  return <>{children}</>;
}

export default JwtProvider;
